import { api_v2 as api } from "@/api/axios.config"
import { toSnake } from "@/utils/caseConverter"

export interface UserProfileAPIResponse {
  pes_id?: number
  pes_nome: string
  pes_telefone: string
  pes_email: string
  pes_instagram: string | null
  pes_nascimento: string
  pes_nome_cracha: string
  pes_nome_certificado: string
  pes_cpf: string
  pes_sexo: string
  pes_chocolate_preferido: string | null
  pes_pare_id: number | null
  pare_descricao: string | null
  pes_cep: string
  pes_endereco: string | null
  pes_complemento: string | null
  pes_bairro: string | null
  pes_cidade: number | null
  pes_estado: number | null
  pes_classificacao: number | null
  pes_tamanho_camisa: string | null
  pes_numero_calcado: string | null
  pes_numero_sandalia: string | null
  pes_numero_bermuda: string | null
  pes_tamanho_calca: string | null
}

export interface UserProfilePayload {
  pes_nome: string
  pes_telefone: string
  pes_email: string
  pes_instagram: string
  pes_nascimento: string
  pes_nome_cracha: string
  pes_nome_certificado: string
  pes_cpf: string
  pes_sexo: string
  pes_chocolate_preferido: string
  pes_pare_id: number
  pare_descricao: string
  pes_cep: string
  pes_endereco: string
  pes_complemento: string
  pes_bairro: string
  pes_cidade: number
  pes_estado: number
  pes_classificacao: number
  pes_tamanho_camisa: string
  pes_numero_calcado: string
  pes_numero_sandalia: string
  pes_numero_bermuda: string
  pes_tamanho_calca: string
}

export interface UserProfileFormData {
  pes_nome: string
  pes_telefone: string
  pes_email: string
  pes_instagram: string
  pes_nascimento: string
  pes_nome_cracha: string
  pes_nome_certificado: string
  pes_cpf: string
  pes_sexo: string
  pes_chocolate_preferido: string
  pes_pare_id: string
  pes_cep: string
  pes_endereco: string
  pes_complemento: string
  pes_bairro: string
  pes_cidade: string
  pes_estado: string
  pes_classificacao: string
  pes_tamanho_camisa: string
  pes_numero_calcado: string
  pes_numero_sandalia: string
  pes_numero_bermuda: string
  pes_tamanho_calca: string
}

export interface AreaAtuacaoItem {
  pare_id: number
  pare_descricao: string
}

export interface CidadeItem {
  id: number
  nome: string
  estado_id: number
  estado_nome: string
  estado_sigla: string
}

export const getUserProfile = async () => {
  const res = await api.get("/app/user")
  return { ...res, data: toSnake(res.data.data) as UserProfileAPIResponse }
}

export const updateUserProfile = async (data: Partial<UserProfilePayload>) => {
  return api.post("/app/user", data)
}

export const uploadProfileImage = async (pes_uid: string, file: File) => {
  const formData = new FormData()
  formData.append("foto", file)
  const res = await api.post(`/media/imagem-pes/uid/${pes_uid}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return { ...res, data: { url: res.data.data?.url as string } }
}

export const getAreasAtuacao = async () => {
  const res = await api.get("/app/areas")
  return { ...res, data: toSnake(res.data.data) as AreaAtuacaoItem[] }
}

export const getCidades = async () => {
  const res = await api.get("/app/cidades")
  return { ...res, data: toSnake(res.data.data) as CidadeItem[] }
}
